export const TENANCY_ENABLED = process.env.TENANCY_ENABLED === true ||
  process.env.TENANCY_ENABLED === 'true';

export const TENANT_HOSTS = {
  'vnvjntdc.org': 1,
  'www.vnvjntdc.org': 1,
  'runedc.vnvjntdc.org': 2,
  'wkmcvdedc.vnvjntdc.org': 3,
  'badpmedc.vnvjntdc.org': 4,
  'skedc.vnvjntdc.org': 5,
  'wcedc.vnvjntdc.org': 6,
  'ssgnsedc.vnvjntdc.org': 7
};

export function normalizePortalHost(host) {
  if (typeof host !== 'string') throw new Error('Portal hostname is required.');
  const normalized = host.trim().toLowerCase();
  if (!Object.prototype.hasOwnProperty.call(TENANT_HOSTS, normalized)) {
    throw new Error('This portal hostname is not configured for a tenant.');
  }
  return normalized;
}

export function parseTenantResponse(body) {
  let result = body;
  for (let i = 0; i < 2 && typeof result === 'string'; i++) {
    result = JSON.parse(result);
  }
  return result;
}

export function validateEstablishmentDate(value) {
  if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    throw new Error('The corporation establishment date must use YYYY-MM-DD.');
  }
  const date = new Date(value + 'T00:00:00Z');
  if (!Number.isFinite(date.getTime()) || date.toISOString().slice(0, 10) !== value) {
    throw new Error('The corporation establishment date is invalid.');
  }
  return value;
}

export function validateBranding(body, portalHost) {
  const branding = parseTenantResponse(body);
  if (!branding || !Number.isInteger(branding.TenantId) ||
      Object.keys(TENANT_HOSTS).every(host => TENANT_HOSTS[host] !== branding.TenantId)) {
    throw new Error('The API returned an invalid tenant configuration.');
  }
  const hostname = normalizePortalHost(branding.Hostname);
  if (TENANT_HOSTS[hostname] !== branding.TenantId ||
      (portalHost && TENANT_HOSTS[normalizePortalHost(portalHost)] !== branding.TenantId)) {
    throw new Error('The API tenant does not match the portal hostname.');
  }
  ['Code', 'NameMarathi', 'NameEnglish', 'LogoUrl', 'WebsiteUrl'].forEach(key => {
    if (typeof branding[key] !== 'string' || !branding[key].trim()) {
      throw new Error('Tenant configuration is missing ' + key + '.');
    }
  });
  if (branding.EstablishmentDate !== undefined) {
    validateEstablishmentDate(branding.EstablishmentDate);
  }
  const website = new URL(branding.WebsiteUrl);
  if (website.protocol !== 'https:' || website.username || website.password ||
      TENANT_HOSTS[normalizePortalHost(website.hostname)] !== branding.TenantId) {
    throw new Error('The tenant website does not match its approved hostname.');
  }
  const logo = new URL(branding.LogoUrl, website.origin);
  if (logo.protocol !== 'https:' || logo.username || logo.password ||
      !Object.prototype.hasOwnProperty.call(TENANT_HOSTS, logo.hostname)) {
    throw new Error('The tenant logo must use an approved portal HTTPS URL.');
  }
  return Object.assign({}, branding, {
    Hostname: hostname,
    WebsiteUrl: website.origin,
    LogoUrl: logo.href
  });
}

export function verificationUrl(branding, applicationId, loiNumber) {
  if (!applicationId || !loiNumber) {
    throw new Error('An application ID and issued LOI number are required for verification.');
  }
  return branding.WebsiteUrl.replace(/\/$/, '') + '/verifyloi/' +
    encodeURIComponent(applicationId) + '/' + encodeURIComponent(loiNumber);
}



// WEBPACK FOOTER //
// ./src/services/tenant.js